import React from 'react';
import { connect } from 'react-redux';

import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import { IEducationCategory } from '@src/model/educationcategory/EducationCategory';
import CollectionBusinessStore from '@src/service/business/common/collectionBusinessStore';
import { Checkbox } from 'antd';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';


// -- Prop types
// ----------
export interface IEducationCategoryCheckboxGroupOwnProps {
  value?: IEducationCategory[];
  onChange?: (value: IEducationCategory[]) => void;
  disabled?: boolean;
}
export interface IEducationCategoryCheckboxGroupStateProps {
  educationCategoryList: IEducationCategory[];
}
export interface IEducationCategoryCheckboxGroupDispatchProps {
}
type IEducationCategoryCheckboxGroupProps = IEducationCategoryCheckboxGroupOwnProps & IEducationCategoryCheckboxGroupStateProps & IEducationCategoryCheckboxGroupDispatchProps & IWithLocalizeOwnProps;

interface IEducationCategoryCheckboxGroupState {
  initialValues?: string[];
}

// -- Component
// ----------

/** Display education category checkbox list */
class EducationCategoryCheckboxGroup extends React.Component<IEducationCategoryCheckboxGroupProps, IEducationCategoryCheckboxGroupState> {
  state: IEducationCategoryCheckboxGroupState = {
    initialValues: undefined,
  };

  componentDidMount() {
    this.handleInitalValues();
  }

  componentDidUpdate(prevProps: IEducationCategoryCheckboxGroupProps, prevState: IEducationCategoryCheckboxGroupState) {
    if (prevProps.value !== this.props.value) {
      this.handleInitalValues();
    }
  }

  handleInitalValues = () => {
    const initialValues = this.props.value?.map((value) => value.id);
    this.setState({ initialValues });
  }

  render = () => {
    return (
      <Checkbox.Group disabled={this.props.disabled} value={this.state.initialValues} onChange={this.handleChange}>
        {this.props.educationCategoryList?.map((category) => <Checkbox key={category.id} value={category.id}>
          {category.name}
        </Checkbox>)}
      </Checkbox.Group>
    );
  };

  handleChange = (data: CheckboxValueType[]) => {
    const result = this.props.educationCategoryList.filter((category) => data.includes(category.id));
    this.props.onChange?.(result);
  }

}

// -- HOCs and exports
// ----------

// `state` parameter needs a type annotation to type-check the correct shape of a state object but also it'll be used by "type inference" to infer the type of returned props
const mapStateToProps = (state: any, ownProps: IEducationCategoryCheckboxGroupOwnProps): IEducationCategoryCheckboxGroupStateProps => ({
  educationCategoryList: CollectionBusinessStore.selectors.getCollectionContent(state, 'EducationCategory'),
});

// `dispatch` parameter needs a type annotation to type-check the correct shape of an action object when using dispatch function
const mapDispatchToProps = (dispatch: any): IEducationCategoryCheckboxGroupDispatchProps => ({
});

export default connect(mapStateToProps, mapDispatchToProps)((withLocalize<IEducationCategoryCheckboxGroupOwnProps>(EducationCategoryCheckboxGroup as any)));
